module.exports = __webpack_public_path__ + "static/media/natural_language.5fad515b.svg";